export default {
      id: "group-2-usage",
      viewBox: "0 0 26 29",
      url: __webpack_public_path__ + "sprite.svg#group-2",
      toString: function () {
        return this.url;
      }
    }